import { selectors } from "store";

const monitorSelectors = selectors.monitor;

export default monitorSelectors;
